import { Plus } from 'react-bootstrap-icons';
import { CareMapprTextarea } from '../../../../../components/Inputs/textarea';
import { useLettersForm } from '../provider/LettersFormContext';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import CareMapprIconButton from '../../../../../components/Button/CareMapprIconButton';
import TrashIcon from '../../../../../../assets/img/button-icons/trash-red.svg';
import { useMedicationProfileDirty } from '../../../context/MedicationProfileDirtyProvider';

const MonitoringRequired = () => {
  const { doctorLetterForm } = useLettersForm();
  const { setIsDirty } = useMedicationProfileDirty();
  const monitoringRequireds = doctorLetterForm.getValues()
    .monitoringRequired || [''];
  return (
    <div className="letters-form-add-item">
      <div className="d-flex align-items-start flex-column gap-2">
        <label>Monitoring required</label>
        {monitoringRequireds.map((required, index) => {
          return (
            <div
              key={`monitoringRequired-${index}`}
              className="width-100-percent d-flex align-items-end gap-2"
            >
              <CareMapprTextarea
                autoResize
                key={`monitoringRequired-${index}`}
                placeholder="Start typing..."
                value={required}
                className="flex-grow-1 width-80-percent"
                inputClassName="w-100"
                onChange={(e) => {
                  setIsDirty(true);
                  doctorLetterForm.setValue(
                    `monitoringRequired.${index}`,
                    e.target.value,
                    { shouldDirty: true },
                  );
                }}
              />
              {monitoringRequireds.length > 1 && (
                <CareMapprIconButton
                  className="m-0 width-70 min-width-0"
                  icon={
                    <img src={TrashIcon} className="icon" alt="edit pen icon" />
                  }
                  onClick={() => {
                    const updated = monitoringRequireds.filter(
                      (_, i) => i !== index,
                    );
                    doctorLetterForm.setValue(`monitoringRequired`, updated, {
                      shouldDirty: true,
                    });
                  }}
                />
              )}
            </div>
          );
        })}
        <CareMapprButton
          extraClassNames="ms-auto m-0 width-120 ps-0"
          labelClassName="add-line-button"
          type="button"
          variant="link"
          label="Add line"
          startIcon={<Plus size={20} color="#6b6964" />}
          style={{ textDecoration: 'none' }}
          onClick={() => {
            doctorLetterForm.setValue(
              `monitoringRequired.${monitoringRequireds.length}`,
              '',
              { shouldDirty: true },
            );
          }}
        />
      </div>
    </div>
  );
};

export default MonitoringRequired;
